export default __webpack_public_path__ + "static/award-2-cl-3b7bd58e5da763f84b2d982d2609be43.png";